export default __webpack_public_path__ + "static/property-img-1_1600-4572d57020cfb969e2d32290ac6e9158.jpg";